import { ESocialType } from '../../types/social';
export var SOCIAL_NETWORKS = [ESocialType.MailRu, ESocialType.VK, ESocialType.AppleID, ESocialType.OK, ESocialType.Gosuslugi, ESocialType.Google, ESocialType.Facebook];
export var VISIBLE_SOCIALS_COUNT = 3;

// Если сейчас доступно INITIALLY_EXPANDED_SOCIALS_LIMIT соц сетей,
// то нет смысла скрывать их под кнопкой "раскрыть", показываем все сразу
export var INITIALLY_EXPANDED_SOCIALS_LIMIT = 5;